const stats = [
  { value: '15+', label: 'Yıl Deneyim' },
  { value: '500+', label: 'Müşteri' },
  { value: '12', label: 'Hizmet Alanı' },
  { value: '%100', label: 'Şeffaflık' },
];

const values = [
  { icon: 'ri-shield-check-line', label: 'Mesleki Etik' },
  { icon: 'ri-eye-line', label: 'Şeffaflık' },
  { icon: 'ri-time-line', label: 'Zamanında Teslimat' },
  { icon: 'ri-lock-line', label: 'Gizlilik' },
];

export default function About() {
  return (
    <section id="hakkimizda" className="py-24 md:py-32 bg-[#F5F7FA]">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="flex flex-col lg:flex-row items-center gap-12 lg:gap-20">
          {/* Left - Image */}
          <div className="w-full lg:w-[45%] flex-shrink-0 relative">
            <div className="rounded-2xl overflow-hidden">
              <img
                src="https://public.readdy.ai/ai/img_res/fb374ca208efc37a2b926dcc856c8012.jpg"
                alt="Mali Müşavir"
                className="w-full h-[400px] md:h-[480px] object-cover object-top"
              />
            </div>
            {/* Overlay card */}
            <div className="absolute bottom-6 right-6 bg-white rounded-xl p-4 flex items-center gap-3">
              <div className="w-10 h-10 flex items-center justify-center bg-[#0A2540] rounded-lg">
                <i className="ri-award-line text-white text-base"></i>
              </div>
              <div>
                <div className="text-[#0A2540] font-bold text-lg leading-none">15+</div>
                <div className="text-gray-500 text-xs mt-0.5">Yıl Deneyim</div>
              </div>
            </div>
          </div>

          {/* Right - Content */}
          <div className="flex-1">
            <span className="text-xs font-semibold tracking-widest text-[#60A5FA] uppercase">Hakkımızda</span>
            <h2 className="text-3xl md:text-4xl font-bold text-[#0A2540] mt-3 mb-6 leading-tight">
              Güven ve Şeffaflık<br />Temel Değerlerimiz
            </h2>
            <p className="text-gray-500 text-sm leading-relaxed mb-4">
              Serbest Mali Müşavirlik mesleğini, yalnızca yasal yükümlülükleri yerine getirmek olarak değil; müşterilerimizin finansal geleceğini birlikte şekillendirmek olarak görüyoruz.
            </p>
            <p className="text-gray-500 text-sm leading-relaxed mb-8">
              15 yılı aşkın deneyimimizle, küçük işletmelerden orta ölçekli şirketlere kadar geniş bir yelpazede hizmet veriyoruz. Her müşterimizin durumu farklıdır; bu nedenle standart çözümler yerine, ihtiyaca özel yaklaşımlar geliştiriyoruz.
            </p>

            {/* Values */}
            <div className="grid grid-cols-2 gap-3 mb-10">
              {values.map((v) => (
                <div key={v.label} className="flex items-center gap-3 p-3 bg-white rounded-xl">
                  <div className="w-8 h-8 flex items-center justify-center bg-[#F5F7FA] rounded-lg">
                    <i className={`${v.icon} text-[#0A2540] text-sm`}></i>
                  </div>
                  <span className="text-[#0A2540] text-sm font-medium">{v.label}</span>
                </div>
              ))}
            </div>

            {/* Stats */}
            <div className="grid grid-cols-4 gap-4 pt-8 border-t border-gray-200">
              {stats.map((s) => (
                <div key={s.label} className="text-center">
                  <div className="text-2xl font-black text-[#0A2540]">{s.value}</div>
                  <div className="text-gray-400 text-xs mt-1">{s.label}</div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
